import React from 'react';
import { FormInputSelect } from 'components/form';
import { formatCurrency } from 'utils';
import { ProductConfig } from '../../../../../types';
import { TruckSuiteRateTerm } from './types';

interface Props {
  terms: TruckSuiteRateTerm[];
  configuration: ProductConfig;
  handleTermChange: (term: TruckSuiteRateTerm) => void;
}

export const Fields = ({ terms, configuration, handleTermChange }: Props) => {
  const sortedTerms: TruckSuiteRateTerm[] = [...terms].sort((a, b) => a.termMonths - b.termMonths);

  const selectedTerm: TruckSuiteRateTerm | null = configuration.coverage ?? null;

  const getTermValue = (): string => {
    if (!selectedTerm) return '';
    const idx = sortedTerms.findIndex(
      t => t.termMonths === selectedTerm.termMonths && t.termOdometer === selectedTerm.termOdometer
    );
    return idx >= 0 ? idx.toString() : '';
  };

  const getTermLabel = (term: TruckSuiteRateTerm): string => {
    const base = `${term.termMonths} Months${
      term.termOdometer ? ` / ${term.termOdometer.toLocaleString()} Miles` : ''
    }`;
    return `${base} \u2014 ${formatCurrency(term.suggestedRetailCost)}`;
  };

  return (
    <>
      <FormInputSelect
        variant="standard"
        label="Term"
        onChange={(value: string) => {
          const term = sortedTerms[parseInt(value, 10)];
          if (term) handleTermChange(term);
        }}
        value={getTermValue()}
        options={[
          { label: 'Select Term', value: '' },
          ...sortedTerms.map((term, index) => ({
            label: getTermLabel(term),
            value: index.toString(),
          })),
        ]}
      />

      {selectedTerm?.deductible?.description && (
        <FormInputSelect
          variant="standard"
          label="Deductible"
          disabled
          onChange={() => undefined}
          value="0"
          options={[{ label: selectedTerm.deductible.description, value: '0' }]}
        />
      )}
    </>
  );
};
